/**
 * Domínio próprio de farmácia (`www.drogariax.com.br` em vez de
 * `<slug>.sites.oniochat.com.br`). ADR-025 Fase 2.
 *
 * Só helpers puros de string — este módulo roda no browser (painel) e no
 * renderer/painel-api. Nada de `node:crypto`, Firestore ou Certificate Manager.
 */
/** Estados do domínio próprio, guardados em `farmacias/{slug}.customDomainStatus`. */
export const CUSTOM_DOMAIN_STATES = [
    "none", // sem domínio próprio
    "pending_dns", // cert criado; esperando o registro A apontar pro load balancer
    "provisioning", // DNS ok; Certificate Manager emitindo o cert
    "active", // cert ativo; servindo
    "error", // emissão falhou / erro na API
];
/** RFC-1123: um label DNS (minúsculas, dígitos, hífen; sem hífen nas pontas; 1–63). */
const DNS_LABEL_RE = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;
/**
 * Normaliza uma entrada livre do suporte para um hostname:
 * remove esquema, porta, path/query/hash, ponto final e caixa. Retorna `null`
 * se não for um hostname plausível (precisa de ao menos um ponto e um TLD não
 * numérico).
 */
export function normalizeHost(input) {
    if (!input)
        return null;
    let h = String(input).trim().toLowerCase();
    h = h.replace(/^[a-z][a-z0-9+.-]*:\/\//, ""); // esquema://
    h = h.replace(/[/?#].*$/, ""); // path / query / hash
    h = h.replace(/:\d+$/, ""); // :porta
    h = h.replace(/^\.+|\.+$/g, ""); // pontos nas pontas
    if (!h || h.length > 253)
        return null;
    const labels = h.split(".");
    if (labels.length < 2)
        return null; // exige um domínio, não um label solto
    if (!labels.every((l) => DNS_LABEL_RE.test(l)))
        return null;
    const tld = labels[labels.length - 1];
    if (!/[a-z]/.test(tld) || tld.length < 2)
        return null; // TLD tem letra
    return h;
}
/**
 * Um domínio próprio precisa ser externo — nunca sob o domínio base da
 * plataforma (a farmácia já tem `<slug>.<baseDomain>` de graça).
 */
export function isEligibleCustomDomain(host, baseDomain) {
    const b = baseDomain.trim().toLowerCase().replace(/^\.+|\.+$/g, "");
    return !!host && host !== b && !host.endsWith(`.${b}`);
}
/**
 * O par www↔apex que um domínio próprio cobre. `primary` é exatamente o que o
 * suporte digitou (vira o canonical da página); `secondary` é o contraparte
 * www/apex, provisionado junto pra `drogariax.com.br` e `www.drogariax.com.br`
 * servirem os dois.
 */
export function customDomainPair(primaryHost) {
    const primary = primaryHost.toLowerCase();
    const secondary = primary.startsWith("www.")
        ? primary.slice(4)
        : `www.${primary}`;
    return { primary, secondary };
}
/**
 * Valida uma entrada de domínio próprio de ponta a ponta. Retorna o par de
 * hosts a provisionar, ou uma mensagem de erro pronta pra UI.
 */
export function parseCustomDomainInput(input, baseDomain) {
    const host = normalizeHost(input);
    if (!host)
        return { ok: false, error: "Informe um domínio válido, ex.: www.drogariax.com.br" };
    if (!isEligibleCustomDomain(host, baseDomain)) {
        return { ok: false, error: `O domínio não pode estar sob ${baseDomain}.` };
    }
    const { primary, secondary } = customDomainPair(host);
    return { ok: true, primary, secondary };
}
//# sourceMappingURL=custom-domain.js.map